import { render, staticRenderFns } from "./wxMiniRedirect.vue?vue&type=template&id=4af7aba8&scoped=true"
import script from "./wxMiniRedirect.vue?vue&type=script&lang=js"
export * from "./wxMiniRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af7aba8",
  null
  
)

export default component.exports